import { isSuperAdmin } from '@/functions/auth';
import User from '@/models/User';

export const getAuthorizedUnits = (user?: User) => {
  if (user) {
    return isSuperAdmin(user.userType) ? undefined : user.unitsIds;
  } else return undefined;
};
